export default "__VITE_ASSET__b1c9473d__"